import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import MarketingHome from './MarketingHome';
import { SiteRenderer } from '../components/website/SiteRenderer';
import { previewHeaders } from '../lib/site';

// Tenant storefront entry: renders the company's published website when one exists, else the legacy hard-coded home page.
export default function StorefrontPage() {
  const page = useLocation().pathname.replace(/^\/+|\/+$/g, '');
  const [site, setSite] = useState(undefined);
  useEffect(() => { axios.get('/public/website', { headers: previewHeaders() }).then((r) => setSite(r.data)).catch(() => setSite({ configured: false })); }, []);
  if (site === undefined) return <div style={{ minHeight: '100vh', background: '#0A0A0A' }} />;
  if (!site.configured) return <MarketingHome />;
  const slug = page && site.pages[page] ? page : 'home';
  return <SiteRenderer site={site} pageSlug={slug} />;
}
